import { render, staticRenderFns } from "./EventModalContent.vue?vue&type=template&id=76edc38b"
import script from "./EventModalContent.vue?vue&type=script&lang=js"
export * from "./EventModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports